export const PP_Auth_Token = 'PP_Auth_Token';
export const SET_CHAMPIONSHIP_ROUTE = '/api/set-championship';

export enum AzureStorageContainers {
  ONLINE_ENTRY_HANDICAP_CERTIFICATES,
  ACCREDITATION_CONTACT_IMAGES,
  ACCREDITATION_DOCUMENTS,
}
